export default __webpack_public_path__ + "static/media/jacksonhole_2.0aa9eb6c.jpg";